import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'next-common-lib';
import i18n from 'i18n';

export const DeleteButton = ({ handleOnclick }) => {
  return (
    <Button
      className="close"
      size="xxs"
      title={i18n.t('EM_T_DELETE')}
      iconInfo={{ className: 'ic-close', size: 'sm' }}
      onClick={handleOnclick}
    />
  );
};
DeleteButton.propTypes = {
  handleOnclick: PropTypes.func.isRequired,
};
DeleteButton.defaultProps = {};
export default DeleteButton;
